// Enum for defining a set of custom screen names
export enum ScreenNames {
	RewardOffers = 'Reward_Offers',
	RoyaltyProgramInfo = 'Royalty_Program_Info',
}
